import { render, staticRenderFns } from "./ProducerProducts.vue?vue&type=template&id=4951f92c&scoped=true&"
import script from "./ProducerProducts.vue?vue&type=script&lang=js&"
export * from "./ProducerProducts.vue?vue&type=script&lang=js&"
import style0 from "./ProducerProducts.vue?vue&type=style&index=0&id=4951f92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4951f92c",
  null
  
)

export default component.exports